import { DivisiResponse } from "../../../../models/Divisi";
import { AdminJobDetailResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function CreateMultipleKandidatFile(data: number[]) {
  const res = await ApiClient.post(`/CreateMultipleKandidatFile`, data);
  return res.data[0];
}

export const useCreateMultipleKandidatFile = mutationWrapper(
  CreateMultipleKandidatFile
);
